module.exports = __webpack_public_path__ + "img/credit_card.c77de0fe.svg";